<template>
  <div class="common-poster-edit">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>海报分享模板</BreadcrumbItem>
          <BreadcrumbItem>添加</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">添加</div>
      </div>
    </div>
    <div class="header-switch">
      <Button type="primary" style="margin-right:20px;" @click="save()">保存</Button>
      <Button @click="exit()">退出</Button>
    </div>

    <div class="poster-edit-content">
      <div class="imgBox">
        <img :src="url">
      </div>
      <div class="popperBox">
        <popper :show-popper="visible" @close="visible=false" placement="right">
          <div slot="content" class="ctt1-poptip">
            <Form ref="formValidate" :label-width="100">
              <FormItem label="添加背景图：">
                <div class="my-upload">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList"
                    :key="'upload' + index"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width: 100px;height: 100px;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                        <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    multiple
                    type="drag"
                    :action="uploadUrl"
                    style="display: inline-block;"
                    v-show="uploadList && uploadList.length < 1"
                  >
                    <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                      <div style="font-size:25px">
                        +
                        <p style="font-size:14px">上传图片</p>
                      </div>
                    </div>
                  </Upload>
                  <iModal title="图片查看" cancel-text v-model="visibleImg">
                    <div style="text-align: center;">
                      <img :src="imgName" v-if="visibleImg" style="max-width: 100%" />
                    </div>
                  </iModal>
                </div>
                <p class="upload-p" style="display:block;font-size:12px;">（图片要求：2M以下的jpg或png格式，总宽度750px）</p>
              </FormItem>
            </Form>
          </div>
        </popper>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import popper from "@components/vue-popper/VuePopper.vue";

export default {
  name: "host-common-posterEdit",
  data() {
    return {
      showTabs: "1",
      visible: true,
      url: "https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/202004/81b11e69a0ec412c81ea40273365fe3e.jpg",
      uploadList: [],
      defaultList: [],
      imgName: "",
      visibleImg: false,
    }
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: {
    ...mapActions({
      addSharePoster: "hostCommonModule/addSharePoster"
    }),
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visibleImg = true;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    exit() {
      this.$router.go(-1);
    },
    async save() {
      if (this.uploadList.length < 1) {
        this.$Message.warning(`请上传背景图`);
        return;
      }
      let url = this.uploadList[0].url;
      let req = {
        ExhibitionId: this.exhibitionInfo.id,
        BackgroundImage: url
      }
      let bool = await this.addSharePoster(req);
      console.log(bool);
    }
  },
  components: {
    popper
  }
}
</script>

<style lang="scss" scoped>
.common-poster-edit {
  .header-switch {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
  .poster-edit-content {
    width: 800px;
    margin: 50px auto;
    display: flex;
    .imgBox {
      width: 377px;
      height: 626px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .popperBox {
      margin: 145px 40px 0 0;
      .ctt1-poptip {
        width: 540px;
        height: 288px;
        padding: 60px;
      }
    }
  }
}
</style>
